module.exports = __webpack_public_path__ + "img/7e54c1c.png";